import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import '../css/FeaturedSlider.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import { useNavigate } from 'react-router';
import NewlineText from './NewlineText';


function FeaturedSlider(props) {
  const projects = props.projects;
  const images = props.images;
  const videos = props.videos;

  //When there are no featured projects, show nothing
  if (projects.length < 1) return;
  const sliders = projects.map((project) =>
    <SwiperSlide key={project.ID}><SingleFeaturedSlider project={project} images={images} videos={videos} /></SwiperSlide>
  );

  //sort projects based on date
  projects.sort((a, b) => {
    return new Date(b.DATE) - new Date(a.DATE);
  });

  return (
    <section className='featured'>
      <h1> Featured </h1>
      <div className='featured-slider-container featured bg-color-1'>
        <Swiper
          modules={[Autoplay, EffectFade, Navigation, Pagination]}
          direction={'horizontal'}
          spaceBetween={50}
          slidesPerView={1}
          loop={true}
          allowTouchMove={false}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          effect={'fade'}
          fadeEffect={{
            crossFade: true
          }}
          navigation={{
            prevEl: '.featured-slider-prev',
            nextEl: '.featured-slider-next',
          }}
          pagination={{
            el: '.featured-pagination',
            horizontalClass: 'featured-pagination-hor',
            clickable: true,
            bulletClass: 'featured-pagination-bullet',
            bulletActiveClass: 'featured-pagination-bullet-active',
            renderBullet: function (index, className) {
              return '<span class="' + className + '"></span>';
            },
          }
          }
        >
          {sliders}
        </Swiper>
        <div className='featured-pagination'></div>
      </div>
    </section >
  );
}

FeaturedSlider.propTypes = {
  projects: PropTypes.array,
  images: PropTypes.object,
  videos: PropTypes.object,
};

export default FeaturedSlider;

function SingleFeaturedSlider(props) {
  const project = props.project;
  const images = props.images;
  const videos = props.videos;
  const defaultThumbnailImage = images[project.THUMBNAIL].ORIGINAL;

  const [thumbnailImage, setThumbnailImage] = useState(defaultThumbnailImage);
  const [coverClasses, setCoverClasses] = useState('cover-img hidden');
  const [sliderClasses, setSliderClasses] = useState('featured-volume-slider hidden');
  const [volume, setVolume] = useState(0);
  const videoPlayer = useRef(null);
  const hasVideo = project.VIDEO !== null;

  const navigate = useNavigate();

  const subThumbnails = project.HIGHLIGHTED_IMAGES.slice(0, 6).map((imageID, index) => (
    <div
      key={index}
      className='single-featured-slider-single-subthumbnail'
      onMouseEnter={(e) => handleSubThumbnailHoverEnter(e, images[imageID].ORIGINAL)}
      onMouseLeave={(e) => handleSubThumbnailHoverLeave(e)}
    >
      <img src={images[imageID].THUMBNAIL} />
    </div>
  ));

  function handleSubThumbnailHoverEnter(e, hoverThumbnail) {
    e.currentTarget.classList.add("on-hover")
    setThumbnailImage(hoverThumbnail);
  }

  function handleSubThumbnailHoverLeave(e) {
    e.currentTarget.classList.remove("on-hover")
    setThumbnailImage(defaultThumbnailImage);
  }

  function changeVolume(e) {
    setVolume(e.target.value);
    videoPlayer.current.muted = false;
    videoPlayer.current.volume = volume / 100;
  }

  function handleThumbnailVideoHover(e, isHover) {
    if (!hasVideo)
      return;

    if (isHover) {
      videoPlayer.current.play()

      setCoverClasses('cover-img hidden')
      setSliderClasses('featured-volume-slider ')
    }
    else {
      videoPlayer.current.pause()
      setCoverClasses('cover-img')
      setSliderClasses('featured-volume-slider hidden')
    }
  }
  return (
    <div >
      <div className='single-featured-slider'>
        <div className='single-featured-slider-media-box'>
          <div className='single-featured-slider-thumbnail-box'
            onMouseEnter={(e) => handleThumbnailVideoHover(e, true)}
            onMouseLeave={(e) => handleThumbnailVideoHover(e, false)}>
            <div className='single-featured-slider-thumbnail-trailer' style={{ backgroundImage: `url(${thumbnailImage})` }}>
              {hasVideo && (
                <video
                  poster={thumbnailImage}
                  src={videos[project.VIDEO].SRC}
                  muted
                  loop
                  width={"100%"}
                  height={"100%"}
                  ref={videoPlayer}
                />
              )}
              <input className={sliderClasses} type='range' orient='vertical' min={-1} max={100} value={volume} onChange={(e) => changeVolume(e)} />
              <img className={coverClasses} src={thumbnailImage} />
            </div>
          </div>
          <div className='single-featured-slider-subthumbnails'>
            {subThumbnails}
          </div>
        </div>
        <div className='single-featured-slider-info-box'
          onClick={() => {
            navigate(`/project/${project.PROJECT_SLUG}`)
          }}>
          <div className='single-featured-slider-info-box-top'>
            <div className='single-featured-slider-projectname'><h2>{project.PROJECT_NAME}</h2>
            </div>
            <span className='categories'>
              <span>{project.CATEGORIES}</span>
            </span>
          </div>

          <div className='single-featured-slider-info-box-bottom'>
            <div className='single-featured-slider-usp'>
              <NewlineText text={project.DESCRIPTION} />
            </div>
            <div className='single-featured-slider-CTA-box'>

              <a onClick={() => {
                navigate(`/project/${project.PROJECT_SLUG}`)
              }}>Check it out!</a>

              <div className='icons'>
                {/* TODO: Tooltip */}
                {/* TODO: Variable */}
                {/* <FontAwesomeIcon icon={faGithub} /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
SingleFeaturedSlider.propTypes = {
  project: PropTypes.object,
  images: PropTypes.object,
  videos: PropTypes.object,
};
